import CategorySearch from "./categorySearch.container";

export default CategorySearch;